// Extract File objects from a paste (clipboard) or drag-and-drop event, so a user can add
// documents without saving them first — paste a copied image (Ctrl/Cmd+V) or drag files in.
// Covers clipboardData/dataTransfer .files and the .items list (used for pasted images).
export function filesFromEvent(e) {
  const dt = e.clipboardData || e.dataTransfer;
  if (!dt) return [];

  const files = [];
  if (dt.files && dt.files.length) {
    for (let i = 0; i < dt.files.length; i++) {
      files.push(dt.files[i]);
    }
  } else if (dt.items && dt.items.length) {
    for (let i = 0; i < dt.items.length; i++) {
      const item = dt.items[i];
      if (item.kind === 'file') {
        const f = item.getAsFile();
        if (f) files.push(f);
      }
    }
  }
  return files;
}
